import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { splitLeadingEmoji } from '../utils/emoji.ts';

export class CollectionRevision extends Model<Schemas['collectionRevisions'], Models> {
    get emoji() {
        return splitLeadingEmoji(this.name).emoji;
    }

    get title() {
        return splitLeadingEmoji(this.name).text;
    }
}
